import React from "react";
import { Nav } from "react-bootstrap";
import { useLocation, useSearchParams } from "react-router-dom";
// underline
// tinted   (underline bar; open tab gets a light tint + thick rounded underline)
// vertical
// pills
// capsule
const CustomTabs = ({
  variant = "underline",
  items = [],
  accessor = "tab",
  activeKey,
  linkClassName = "",
  itemClassName = "",
  onChange,
  ...rest
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();

  const handleSelect = (key) => {
    if (onChange) {
      onChange(key);
      return;
    }
    const updated = new URLSearchParams(searchParams);
    updated.set(accessor, key); // Set ?accessor=value
    setSearchParams(updated, { state: location.state });
  };
  return (
    <Nav
      variant={variant}
      activeKey={activeKey || searchParams.get(accessor) || items?.[0]?.key}
      onSelect={handleSelect}
      {...rest}
    >
      {items?.map((item) => (
        <React.Fragment key={item?.key}>
          <Nav.Item className={itemClassName}>
            <Nav.Link
              eventKey={item?.key}
              as="button"
              type="button"
              className={linkClassName}
            >
              {item?.title}
            </Nav.Link>
          </Nav.Item>
        </React.Fragment>
      ))}
    </Nav>
  );
};

export default CustomTabs;
